<template>
  <grid-view :isReadView="isReadView" v-if="isGridView || isCollapsed" />
  <card-view-container v-else-if="isCardView" />
  <detail-view-container v-else-if="isDetailView" />
</template>

<script>
import CardViewContainer from './card-view/CardViewContainer'
import DetailViewContainer from './detail-view/DetailViewContainer'
import GridView from './grid-view/GridView'

export default {
  name: 'ListViewContainer',
  props: ['isReadView'],
  components: {
    CardViewContainer,
    DetailViewContainer,
    GridView,
  },
  computed: {
    isCardView() {
      return this.$get('viewMode') === 'cardView'
    },
    isDetailView() {
      return this.$get('viewMode') === 'detailView'
    },
    isGridView() {
      return this.$get('viewMode') === 'gridView'
    },
    isCollapsed() {
      return this.$get('isCollapsed')
    },
  },
}
</script>
